export const POLICY_TYPES = {
  RANGE: "range",
  VALUE: "value",
  MULTIPLE: "multiple",
} as const;

export type PolicyTypes = (typeof POLICY_TYPES)[keyof typeof POLICY_TYPES];
